import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Newspaper, ArrowsClockwise } from "@phosphor-icons/react";

export default function WeeklyDigestCard() {
  const [text, setText] = useState("");
  const [exists, setExists] = useState(false);
  const [createdAt, setCreatedAt] = useState(null);
  const [generating, setGenerating] = useState(false);
  const esRef = useRef(null);

  useEffect(() => {
    api.get("/ai/digest").then((r) => {
      if (r.data.exists) {
        setText(r.data.text);
        setExists(true);
        setCreatedAt(r.data.created_at);
      }
    }).catch(() => {});
    return () => esRef.current?.close();
  }, []);

  const generate = () => {
    setGenerating(true);
    setText("");
    const es = new EventSource(`${process.env.REACT_APP_BACKEND_URL}/api/ai/digest/stream`, { withCredentials: true });
    esRef.current = es;
    es.onmessage = (e) => {
      try {
        const d = JSON.parse(e.data);
        if (d.t) setText((prev) => prev + d.t);
        if (d.error) toast.error(`Ошибка AI: ${d.error}`);
        if (d.done) {
          es.close();
          setGenerating(false);
          setExists(true);
          setCreatedAt(new Date().toISOString());
        }
      } catch {}
    };
    es.onerror = () => {
      es.close();
      setGenerating(false);
      if (!text) toast.error("Не удалось получить дайджест. Попробуйте ещё раз");
    };
  };

  return (
    <div className="glass-card border-[#a970ff]/30 bg-gradient-to-br from-[#a970ff]/10 to-transparent p-6" data-testid="weekly-digest-card">
      <div className="flex items-center gap-2 mb-1 flex-wrap">
        <Newspaper size={20} weight="fill" className="text-[#a970ff]" />
        <h3 className="font-heading font-semibold text-lg">AI-дайджест недели</h3>
        {createdAt && !generating && (
          <span className="text-xs text-muted-foreground num">
            от {new Date(createdAt).toLocaleDateString("ru-RU", { day: "numeric", month: "short" })}
          </span>
        )}
        <div className="ml-auto">
          <Button size="sm" variant="outline" onClick={generate} disabled={generating} data-testid="weekly-digest-generate-button" className="active:scale-95 transition-transform border-[#a970ff]/40 hover:bg-[#a970ff]/10">
            {generating
              ? <><ArrowsClockwise size={14} className="mr-1.5 animate-spin" /> Анализирую неделю…</>
              : exists
              ? <><ArrowsClockwise size={14} className="mr-1.5" /> Обновить дайджест</>
              : <><Newspaper size={14} weight="fill" className="mr-1.5" /> Сгенерировать дайджест недели</>}
          </Button>
        </div>
      </div>
      {!text && !generating && (
        <p className="text-sm text-muted-foreground mt-2" data-testid="weekly-digest-empty">
          Полный разбор недели: сравнение с прошлой, что сработало, что просело, и план на следующую неделю.
        </p>
      )}
      {(text || generating) && (
        <div className="mt-3 text-sm leading-relaxed whitespace-pre-wrap" data-testid="weekly-digest-text">
          {text}
          {generating && <span className="inline-block w-2 h-4 bg-[#a970ff]/70 ml-0.5 animate-pulse align-text-bottom" />}
        </div>
      )}
    </div>
  );
}
